'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _class = function (_Component) {
  _inherits(_class, _Component);

  function _class() {
    _classCallCheck(this, _class);

    var _this = _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).call(this));

    _this.state = { isHovering: false };
    return _this;
  }

  _createClass(_class, [{
    key: 'render',
    value: function render() {
      var color = this.state.isHovering && this.props.hoverColor ? this.props.hoverColor : this.props.color;
      return _react2.default.createElement(
        'span',
        { onMouseOut: this.onMouseOut.bind(this), onMouseOver: this.onMouseOver.bind(this) },
        _react2.default.createElement(
          'svg',
          { viewBox: '0 0 16 16', width: '100%', height: '100%' },
          _react2.default.createElement('path', { d: 'M1 15v-1.5L7 11v-1C5 9 4 7.333 4 5.042 4 4 4.5 1 7.5 1S11 4 11 5.042C11 7.376 10 9 8 10v1l6 2.5V15H1zm11-9.5C12 2.833 10.834 0 7.5 0S3 2.833 3 5.5c0 2 1.268 4.085 3 5.035L0 13v3l15-.005V13s-5.293-2.29-6-2.465C10.722 9.58 12 7.5 12 5.5zm1 .5h3v1h-3V6zm0 4h3v1h-3v-1zm0-2h3v1h-3V8z', fill: color })
        )
      );
    }
  }, {
    key: 'onMouseOut',
    value: function onMouseOut() {
      this.setState({ isHovering: false });
    }
  }, {
    key: 'onMouseOver',
    value: function onMouseOver() {
      this.setState({ isHovering: true });
    }
  }]);

  return _class;
}(_react.Component);

_class.propTypes = {
  color: _react.PropTypes.string.isRequired,
  hoverColor: _react.PropTypes.string
};
_class.displayName = 'Traits';
exports.default = _class;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ../~/@segment/icons/build/react/Traits.js
// module id = 1098
// module chunks = 0